import {
  IAiCopywritingRecord,
  AiCopywritingRecordStatus,
} from "@/common/entity/AiCopywritingRecord";
import { QueryPageResult } from "@/common/entity/Pagination";
import { IUserInfo } from "@/common/entity/User";
import { request } from "..";

/**
 * 智能创作生成文案结果
 */
export type GenerateAiCopywritingResult = {
  record: IAiCopywritingRecord<AiCopywritingRecordStatus.SUCCESS>;
  userInfo: IUserInfo;
};

/**
 * 智能创作生成文案接口
 * @param desc 文案描述
 * @param length 期待生成文案的字数
 * @param style 生成文案的风格
 * @param isShowToast 请求异常或请求{@link Response.code 响应数据code}不为0时是否使用{@link Message.error}显示对应错误信息
 * @returns 成功时resolve返回{@link Response.data}响应数据，
 * 失败时reject返回{@link import("../../common/entity/Response") Response}响应对象
 */
function generate(
  desc: string,
  length: number,
  style: string = "",
  isShowToast: boolean = true
): Promise<GenerateAiCopywritingResult> {
  return request<GenerateAiCopywritingResult>(
    {
      url: "/ai-copywriter/generate",
      data: {
        copywriterDesc: desc,
        copywriterLength: length,
        copywriterStyle: style,
      },
      timeout: 10 * 60 * 1000,
    },
    isShowToast
  );
}

/**
 * 请求纠错列表
 * @param pageNum 页码
 * @param pageSize 页面大小
 * @param isShowToast 请求异常或请求{@link Response.code 响应数据code}不为0时是否使用{@link Message.error}显示对应错误信息
 */
function list(
  pageNum: number,
  pageSize: number = 10,
  isShowToast: boolean = true
): Promise<QueryPageResult<IAiCopywritingRecord[]>> {
  return request<QueryPageResult<IAiCopywritingRecord[]>>(
    {
      url: "/ai-copywriter/list",
      data: { pageNum, pageSize },
    },
    isShowToast
  );
}

/**
 * 删除智能创作记录
 * @param id 要删除的记录id
 * @param isShowToast 请求异常或请求{@link Response.code 响应数据code}不为0时是否使用{@link Message.error}显示对应错误信息
 */
function del(
  id: number,
  isShowToast: boolean = true
): Promise<IAiCopywritingRecord> {
  return request<IAiCopywritingRecord>(
    { url: "/ai-copywriter/delete", data: { id } },
    isShowToast
  );
}

export const AiCopywritingApis = {
  generate,
  list,
  del,
};
